/* theme.js — CDLM Theme v1.0.35 */

document.addEventListener('DOMContentLoaded', () => {

  // ── Reset de estado — forzar cierre de todos los overlays al cargar ──
  // Necesario porque el hot-reload de Shopify puede inyectar clases del estado anterior
  document.getElementById('search-overlay')?.classList.remove('is-open');
  document.getElementById('filter-overlay')?.classList.remove('open');
  document.getElementById('filter-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.body.style.overflow = '';

  // ── Mobile Menu ──────────────────────────────────────────
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close');

  hamburger?.addEventListener('click', () => {
    mobileMenu?.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  mobileClose?.addEventListener('click', () => {
    mobileMenu?.classList.remove('open');
    document.body.style.overflow = '';
  });

  // Acordeón "Colecciones" en mobile
  document.querySelectorAll('.mobile-nav-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
    });
  });

  // ── Cart Drawer ──────────────────────────────────────────
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartClose   = document.querySelector('.cart-close');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-open-cart]').forEach(t => t.addEventListener('click', openCart));
  cartOverlay?.addEventListener('click', closeCart);
  cartClose?.addEventListener('click', closeCart);

  // ── Ajax Add to Cart ─────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    btn.textContent = 'Agregando…';
    btn.disabled = true;

    // Verificar cantidad actual en carrito antes de agregar
    fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const existing = cart.items.find(i => i.variant_id == variantId);
      if (existing && existing.quantity >= 24) {
        btn.textContent = 'Máx. 24 piezas';
        setTimeout(() => { btn.textContent = 'Agregar al carrito'; btn.disabled = false; }, 2000);
        return Promise.reject('limit');
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(r => r.json());
    })
    .then(() => {
      btn.textContent = '¡Listo!';
      setTimeout(() => {
        btn.textContent = 'Agregar al carrito';
        btn.disabled = false;
      }, 1500);
      // Actualizar contador del carrito
      return fetch('/cart.js');
    })
    .then(r => r.json())
    .then(cart => {
      const bubble = document.getElementById('cart-count');
      if (bubble) bubble.textContent = cart.item_count;
      openCart();
      // Refrescar items del drawer
      refreshCartDrawer();
    })
    .catch(() => {
      btn.textContent = 'Agregar al carrito';
      btn.disabled = false;
    });
  });


  // ── Product Gallery Thumbs ────────────────────────────────
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('#main-product-img');
      if (mainImg) mainImg.src = thumb.dataset.src;
    });
  });

  // ── Variant selector ─────────────────────────────────────
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.variant-options')?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // ── Size buttons ──────────────────────────────────────────
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.size-buttons')?.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
    });
  });

  // ── Quantity controls — Ajax real ─────────────────────────
  function updateCartItem(key, newQty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(r => r.json());
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Actualizar contador del header
        const countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = cart.item_count;
        const drawerCount = document.getElementById('cart-drawer-count');
        if (drawerCount) drawerCount.textContent = `(${cart.item_count})`;

        // Recargar drawer completo via HTML
        fetch('/?section_id=cart-drawer')
          .then(r => r.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('.cart-drawer');
            const curDrawer = document.querySelector('.cart-drawer');
            if (newDrawer && curDrawer) {
              // Preservar clase open para no cerrar el drawer
              const isOpen = curDrawer.classList.contains('open');
              curDrawer.innerHTML = newDrawer.innerHTML;
              if (isOpen) curDrawer.classList.add('open');
            }
            // Re-bind listeners en los nuevos elementos
            bindQtyControls();
            // Re-bind botón cerrar
            const closeBtn = document.querySelector('.cart-close');
            if (closeBtn) closeBtn.addEventListener('click', closeCart);
          });
      });
  }

  function bindQtyControls() {
    // Solo actuar sobre qty-controls dentro del cart drawer, no del cart page
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.qty-control').forEach(ctrl => {
      if (ctrl.dataset.bound) return;
      ctrl.dataset.bound = '1';
      const minus = ctrl.querySelector('[data-minus]');
      const plus  = ctrl.querySelector('[data-plus]');
      const num   = ctrl.querySelector('.qty-number');
      const item  = ctrl.closest('.cart-item');
      const key   = item?.dataset.itemKey;
      if (!num || !key) return;

      minus?.addEventListener('click', () => {
        const v = parseInt(num.textContent);
        const newQty = Math.max(0, v - 1);
        num.textContent = newQty;
        minus.disabled = true;
        plus.disabled = true;
        updateCartItem(key, newQty).then(() => refreshCartDrawer());
      });

      plus?.addEventListener('click', () => {
        const v = parseInt(num.textContent);
        if (v >= 24) return;
        const newQty = v + 1;
        num.textContent = newQty;
        minus.disabled = true;
        plus.disabled = true;
        updateCartItem(key, newQty).then(() => refreshCartDrawer());
      });
    });
  }

  bindQtyControls();

  // ── Marquee duplicate ─────────────────────────────────────
  const track = document.querySelector('.marquee-track');
  if (track) track.innerHTML += track.innerHTML;

  // ── Free shipping bar ─────────────────────────────────────
  const freeBar = document.querySelector('.free-bar-fill');
  if (freeBar) {
    const pct = Math.min((parseInt(freeBar.dataset.total || 0) / 699) * 100, 100);
    freeBar.style.width = pct + '%';
  }

  // ── Search Overlay ────────────────────────────────────────
  const searchOverlay  = document.getElementById('search-overlay');
  const searchInput    = document.getElementById('search-input');
  const btnSearchOpen  = document.getElementById('btn-search-open');
  const btnSearchClose = document.getElementById('btn-search-close');
  const searchResults  = document.getElementById('search-results');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 50);
    if (searchInput && searchInput.value.trim() === '') loadRecent();
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }

  function loadRecent() {
    if (!searchResults) return;
    searchResults.innerHTML = '<div class="search-results-loading">Cargando…</div>';
    fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=5&resources[options][fields]=title&sort_by=created-descending')
      .then(r => r.json())
      .then(data => {
        const products = data?.resources?.results?.products || [];
        renderResults(products, '', 'Novedades');
      })
      .catch(() => { searchResults.innerHTML = ''; });
  }

  btnSearchOpen?.addEventListener('click', openSearch);
  btnSearchClose?.addEventListener('click', closeSearch);

  // Cerrar al hacer clic en el fondo
  searchOverlay?.addEventListener('click', (e) => {
    if (e.target === searchOverlay) closeSearch();
  });

  // Cerrar con Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay && !searchOverlay.hasAttribute('hidden')) closeSearch();
  });

  // Búsqueda predictiva
  let searchTimer = null;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const q = searchInput.value.trim();
    if (q.length < 2) { loadRecent(); return; }
    searchResults.innerHTML = '<div class="search-results-loading">Buscando…</div>';
    searchTimer = setTimeout(() => fetchPredictive(q), 300);
  });

  // Navegar con Enter al primer resultado
  searchInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const first = searchResults?.querySelector('.search-result-item');
      if (first) { e.preventDefault(); window.location.href = first.href; }
    }
  });

  function fetchPredictive(q) {
    fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag`)
      .then(r => r.json())
      .then(data => {
        const products = data?.resources?.results?.products || [];
        renderResults(products, q, 'Resultados');
      })
      .catch(() => {
        searchResults.innerHTML = '<div class="search-results-empty">Error al buscar. Intenta de nuevo.</div>';
      });
  }

  function renderResults(products, q, label) {
    if (!searchResults) return;
    if (products.length === 0) {
      searchResults.innerHTML = q
        ? `<div class="search-results-empty">Sin resultados para "<strong>${q}</strong>"</div>`
        : '';
      return;
    }
    const labelHtml = label ? `<div class="search-results-label">${label}</div>` : '';
    const items = products.map(p => {
      const img = p.featured_image?.url
        ? `<img class="search-result-img" src="${p.featured_image.url}&width=96" alt="${p.title}" loading="lazy">`
        : `<div class="search-result-img"></div>`;
      const price = p.price ? '$' + parseInt(p.price).toLocaleString('es-MX') + ' MXN' : '';
      return `<a href="${p.url}" class="search-result-item">
        ${img}
        <div class="search-result-info">
          <div class="search-result-title">${p.title}</div>
          <div class="search-result-price">${price}</div>
        </div>
      </a>`;
    }).join('');
    const footer = q
      ? `<a href="/search?q=${encodeURIComponent(q)}&type=product" class="search-results-footer">Ver todos los resultados →</a>`
      : `<a href="/collections/all" class="search-results-footer">Ver toda la tienda →</a>`;
    searchResults.innerHTML = labelHtml + items + footer;
  }

  // ── Collection Filters ───────────────────────────────────

  // Collapse/expand grupos
  document.querySelectorAll('[data-filter-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const content = document.getElementById(btn.getAttribute('aria-controls'));
      if (content) content.classList.toggle('is-collapsed', expanded);
    });
  });

  // Buscador dentro de cada filtro
  document.querySelectorAll('[data-filter-search]').forEach(input => {
    const filterId = input.dataset.filterSearch;
    const list     = document.querySelector(`[data-filter-list="${filterId}"]`);
    const noMatch  = document.querySelector(`[data-filter-nomatch="${filterId}"]`);
    if (!list) return;

    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      let visible = 0;
      list.querySelectorAll('.filter-list__item').forEach(item => {
        const label = item.querySelector('.filter-checkbox__label')?.textContent.toLowerCase() || '';
        const match = q === '' || label.includes(q);
        item.hidden = !match;
        if (match) visible++;
      });
      if (noMatch) noMatch.hidden = visible > 0;
    });
  });

  // Submit automático al cambiar checkboxes
  document.querySelectorAll('[data-filter-input]').forEach(input => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      if (form) submitFilterForm(form);
    });
  });

  function submitFilterForm(form) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams();

    // Mantener sort_by si existe
    if (url.searchParams.get('sort_by')) {
      params.set('sort_by', url.searchParams.get('sort_by'));
    }

    // Checkboxes marcados
    form.querySelectorAll('[data-filter-input]:checked').forEach(input => {
      params.append(input.name, input.value);
    });

    // Precio
    const minInput = form.querySelector('[data-filter-price-min]');
    const maxInput = form.querySelector('[data-filter-price-max]');
    if (minInput && minInput.value !== '') params.set(minInput.name, minInput.value);
    if (maxInput && maxInput.value !== '') params.set(maxInput.name, maxInput.value);

    // Sincronizar ambos forms (sidebar + drawer tienen el mismo snippet)
    // Navegar
    const newUrl = url.pathname + (params.toString() ? '?' + params.toString() : '');
    window.location.href = newUrl;
  }

  // Submit precio con botón "Aplicar"
  document.querySelectorAll('.filter-price__apply').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      if (form) submitFilterForm(form);
    });
  });

  // ── Filter Drawer (mobile) ────────────────────────────────
  const filterOverlay  = document.getElementById('filter-overlay');
  const filterDrawer   = document.getElementById('filter-drawer');
  const btnFilterOpen  = document.getElementById('btn-filter-mobile');
  const btnFilterClose = document.getElementById('filter-drawer-close');
  const btnFilterApply = document.getElementById('filter-drawer-close-apply');

  function openFilterDrawer() {
    filterOverlay?.classList.add('open');
    filterDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilterDrawer() {
    filterOverlay?.classList.remove('open');
    filterDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  btnFilterOpen?.addEventListener('click', openFilterDrawer);
  filterOverlay?.addEventListener('click', closeFilterDrawer);
  btnFilterClose?.addEventListener('click', closeFilterDrawer);
  btnFilterApply?.addEventListener('click', closeFilterDrawer);

  // ── Header: ocultar al bajar, mostrar al subir ────────────
  const announcement = document.querySelector('.announcement-bar');
  const header = document.querySelector('.site-header');
  if (!header) return;

  const annH = announcement ? announcement.offsetHeight : 0;
  // El header siempre arranca debajo del announcement via CSS var
  document.documentElement.style.setProperty('--ann-h', annH + 'px');

  let lastY = window.scrollY;
  let ticking = false;
  const THRESHOLD = 80;

  function updateHeader() {
    const y = window.scrollY;
    const goingDown = y > lastY;
    const headerH = header.offsetHeight;
    document.documentElement.style.setProperty('--header-h', headerH + 'px');

    if (y <= 5) {
      // Al tope: volver a posición original bajo announcement
      header.style.transform = 'translateY(' + annH + 'px)';
      header.classList.remove('header--hidden', 'header--compact');
    } else if (goingDown && y > THRESHOLD) {
      // Bajando: ocultar completamente (hacia arriba, su propia altura + ann)
      header.style.transform = 'translateY(-' + (headerH + annH) + 'px)';
      header.classList.add('header--hidden');
      header.classList.remove('header--compact');
    } else if (!goingDown) {
      // Subiendo: mostrar pegado al top del viewport (translateY 0)
      header.style.transform = 'translateY(0)';
      header.classList.remove('header--hidden');
      header.classList.add('header--compact');
    }

    lastY = y;
    ticking = false;
  }

  // Estado inicial
  header.style.transform = 'translateY(' + annH + 'px)';
  header.style.top = '0';
  document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');

  window.addEventListener('scroll', () => {
    if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
  }, { passive: true });

});

  // ── Personalizados — Botones de precio → preseleccionar tipo en formulario ──
  document.querySelectorAll('.pers-precio-card__btn[data-tipo]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const tipo = btn.dataset.tipo;
      const select = document.getElementById('contact_tipo');
      if (select && tipo) {
        select.value = tipo;
        // Highlight suave para indicar que se seleccionó
        select.style.boxShadow = '0 0 0 2px var(--color-primary)';
        setTimeout(() => { select.style.boxShadow = ''; }, 1500);
      }
    });
  });

  // ── WhatsApp flotante ─────────────────────────────────────
  const waBtn   = document.getElementById('wa-btn');
  const waPopup = document.getElementById('wa-popup');

  waBtn?.addEventListener('click', () => {
    const isOpen = waPopup.classList.toggle('is-open');
    waBtn.classList.toggle('is-open', isOpen);
    waBtn.setAttribute('aria-expanded', String(isOpen));
  });

  // Cerrar al hacer click fuera
  document.addEventListener('click', (e) => {
    if (!document.getElementById('wa-float')?.contains(e.target)) {
      waPopup?.classList.remove('is-open');
      waBtn?.classList.remove('is-open');
      waBtn?.setAttribute('aria-expanded', 'false');
    }
  });

  // ── Slider Antes/Después ──────────────────────────────────
  const baSlider = document.getElementById('ba-slider');
  if (baSlider) {
    const before = baSlider.querySelector('.ba-before');
    const handle = baSlider.querySelector('.ba-handle');
    let dragging = false;

    function setPosition(clientX) {
      const rect = baSlider.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.min(Math.max(pct, 1), 99);
      before.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }

    baSlider.addEventListener('mousedown', (e) => { dragging = true; setPosition(e.clientX); });
    window.addEventListener('mousemove', (e) => { if (dragging) setPosition(e.clientX); });
    window.addEventListener('mouseup', () => { dragging = false; });
    baSlider.addEventListener('touchstart', (e) => { dragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
    baSlider.addEventListener('touchmove', (e) => { if (!dragging) return; e.preventDefault(); setPosition(e.touches[0].clientX); }, { passive: false });
    window.addEventListener('touchend', () => { dragging = false; });

  // ── Slider 2 — ancho completo ─────────────────────────────
  const baSlider2 = document.getElementById('ba-slider2');
  if (baSlider2) {
    const before2 = baSlider2.querySelector('.ba-before');
    const handle2 = baSlider2.querySelector('.ba-handle');
    let dragging2 = false;

    function setPosition2(clientX) {
      const rect = baSlider2.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.min(Math.max(pct, 1), 99);
      before2.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle2.style.left = pct + '%';
    }

    baSlider2.addEventListener('mousedown', (e) => { dragging2 = true; setPosition2(e.clientX); });
    window.addEventListener('mousemove', (e) => { if (dragging2) setPosition2(e.clientX); });
    window.addEventListener('mouseup', () => { dragging2 = false; });
    baSlider2.addEventListener('touchstart', (e) => { dragging2 = true; setPosition2(e.touches[0].clientX); }, { passive: true });
    baSlider2.addEventListener('touchmove', (e) => { if (!dragging2) return; e.preventDefault(); setPosition2(e.touches[0].clientX); }, { passive: false });
    window.addEventListener('touchend', () => { dragging2 = false; });
  }

  // ── Product Tabs ───────────────────────────────────────────
  const tabsContainer = document.getElementById('product-tabs');
  if (tabsContainer) {
    tabsContainer.querySelectorAll('.product-tab__btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        // Desactivar todos los botones
        tabsContainer.querySelectorAll('.product-tab__btn').forEach(b => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        // Ocultar todos los paneles
        document.querySelectorAll('.product-tab__panel').forEach(p => p.classList.remove('is-active'));
        // Activar botón
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        // Mostrar panel por ID
        const panel = document.getElementById('tab-' + tab);
        if (panel) panel.classList.add('is-active');
      });
    });
  }
  }